import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const URL = process.env.REACT_APP_API_URL;
// Define a service using a base URL and expected endpoints
export const yeapGoApi = createApi(
  {
    reducerPath: "yeapGoApi",
    baseQuery: fetchBaseQuery({
      baseUrl: URL || "http://10.151.233.96:4040/api/",
    }),
    tagTypes: ["Events", "Users"],
    endpoints: (builder) => ({
      /* Events */
      getEvents: builder.query({
        query: (Token) => ({
          url: `eventos`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Events"],
      }),
      getEvent: builder.query({
        query: ({ Token, id }) => ({
          url: `eventos/${id}`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Events"],
      }),
      getSeveridades: builder.query({
        query: ({ Token }) => ({
          url: `eventos/severidad/`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Events"],
      }),
      updateEvent: builder.mutation({
        query({ Token, id, body }) {
          return {
            url: `eventos/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Events"],
      }),
      /* Analists */
      getAnalistas: builder.query({
        query: ({ Token }) => ({
          url: `analistas`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
      }),
      getOperators: builder.query({
        query({ Token }) {
          return {
            url: `operadores`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        providesTags: ["Users"],
      }),
      /* Users */
      getUsers: builder.query({
        query({ Token }) {
          return {
            url: `usuarios`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        providesTags: ["Users"],
      }),
      deleteUser: builder.mutation({
        query({ Token, body }) {
          return {
            url: `usuarios/`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      changePassword: builder.mutation({
        query({ Token, body }) {
          return {
            url: `usuarios/`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      activeUser: builder.mutation({
        query({ Token, body }) {
          return {
            url: `usuarios/active`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      createUser: builder.mutation({
        query({ Token, body }) {
          return {
            url: `usuarios/`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      registerSession: builder.mutation({
        query({ Token, body }) {
          return {
            url: `auth/session`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      updateUser: builder.mutation({
        query({ Token, body, id }) {
          return {
            url: `usuarios/edit/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Users"],
      }),
      /* Statistics */
      getHistoricoNodo: builder.query({
        query: ({ Token, Nodo, Sensor }) => ({
          url: `estadisticas/historico/nodo`,
          method: "GET",
          params: { Nodo, Sensor },
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
      }),
      getAreaStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/area`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getSeveridadStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/severidad`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getTipoEventoStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/tipoEvento`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getSensoresStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/sensor`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getEnvironmentStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/ambiente`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getPlatformStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, TipoTicket }) => ({
          url: `estadisticas/plataforma`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getEnvironmentSensorsStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, ambiente, TipoTicket }) => ({
          url: `estadisticas/ambienteSensor`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, ambiente, TipoTicket },
        }),
        providesTags: ["Events"],
      }),
      getAnalistAlertsStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal }) => ({
          url: `estadisticas/analistas/alertasGestionadas`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },

          params: { fechaInicial, fechaFinal },
        }),

        providesTags: ["Events"],
      }),

      getTiempoGestionStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, Operador, TipoTicket }) => ({
          url: `estadisticas/tiempoGestionAlerta`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },

          params: { fechaInicial, fechaFinal, Operador, TipoTicket },
        }),

        providesTags: ["Events"],
      }),

      getAnalistTimeStatistics: builder.query({
        query: ({ Token, fechaInicial, fechaFinal }) => ({
          url: `estadisticas/analistas/tiempoPromedio`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },

          params: { fechaInicial, fechaFinal },
        }),

        providesTags: ["Events"],
      }),
      /* Sensors */
      getSensores: builder.query({
        query: ({ Token }) => ({
          url: `sensores`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Sensores"],
      }),
      updateSensor: builder.mutation({
        query({ Token, id, body }) {
          return {
            url: `sensores/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Sensores"],
      }),
      createSensor: builder.mutation({
        query({ Token, body }) {
          return {
            url: `sensores/`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Sensores"],
      }),
      deleteSensor: builder.mutation({
        query({ Token, id }) {
          return {
            url: `sensores/delete/${id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        invalidatesTags: ["Sensores"],
      }),
      getEventsReport: builder.query({
        query: ({
          Token,
          fechaInicial,
          fechaFinal,
          Nodo,
          Ambiente,
          Caption,
        }) => ({
          url: `estadisticas/historico/eventos`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },

          params: { fechaInicial, fechaFinal, Nodo, Ambiente, Caption },
        }),

        providesTags: ["Events"],
      }),
      /* Monitoreo */

      getConteoMonitoreo: builder.query({
        query: ({ Token }) => ({
          url: `monitoreo/conteo`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Monitoreo"],
      }),
      getNodosStats: builder.query({
        query: ({ Token, fechaInicial, fechaFinal,ambiente }) => ({
          url: `monitoreo/stats`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal,ambiente },
        }),
        providesTags: ["Monitoreo"],
      }),
      getNodosStatsMonth: builder.query({
        query: ({ Token, fechaInicial, fechaFinal,ambiente }) => ({
          url: `monitoreo/stats/month`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal,ambiente },
        }),
        providesTags: ["Monitoreo"],
      }),
      getNodosHistorico: builder.query({
        query: ({ Token, fechaInicial, fechaFinal }) => ({
          url: `monitoreo/history`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal },
        }),
        providesTags: ["Monitoreo"],
      }),
      getNodos: builder.query({
        query: ({ Token }) => ({
          url: `monitoreo/`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Monitoreo"],
      }),
      getNodosAlertas: builder.query({
        query: ({ Token }) => ({
          url: `monitoreo/alertas`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Monitoreo"],
      }),
      aprobarInterfaces: builder.mutation({
        query({ Token, body }) {
          return {
            url: `monitoreo/interfaces`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Monitoreo"],
      }),
      aprobarNodos: builder.mutation({
        query({ Token, body }) {
          return {
            url: `monitoreo/nodos`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Monitoreo"],
      }),
      aprobarVolumenes: builder.mutation({
        query({ Token, body }) {
          return {
            url: `monitoreo/volumenes`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Monitoreo"],
      }),
      /* Calendar */
      getAmbientes: builder.query({
        query: ({ Token }) => ({
          url: `turnos/ambientes`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),

        providesTags: ["Calendar"],
      }),
      getUsersCalendar: builder.query({
        query: ({ Token }) => ({
          url: `turnos/users`,

          method: "GET",

          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),

        providesTags: ["Calendar"],
      }),
      createUserCalendar: builder.mutation({
        query({ Token, body }) {
          return {
            url: `turnos/users`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Calendar"],
      }),
      changeStateUserCalendar: builder.mutation({
        query({ id }) {
          return {
            url: `turnos/users/${id}`,
            method: "PUT",
          };
        },
        invalidatesTags: ["Calendar"],
      }),
      getSpecialists: builder.query({
        query: ({ Token }) => ({
          url: `turnos/specialists`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }),
        providesTags: ["Calendar"],
      }),
      updateSpecialists: builder.mutation({
        query({ Token, id, body }) {
          return {
            url: `turnos/specialists/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Calendar"],
      }),
      createSpecialists: builder.mutation({
        query({ Token, body }) {
          return {
            url: `turnos/specialists/`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Calendar"],
      }),
      deleteSpecialists: builder.mutation({
        query({ Token, id }) {
          return {
            url: `turnos/specialists/delete/${id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        invalidatesTags: ["Calendar"],
      }),

      getSTTotalTimeByUser: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, horaInicio, horaFin }) => ({
          url: `estadisticas/sessions/TotalTimeByUser`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, horaInicio, horaFin },
        }),
        providesTags: ["Events"],
      }),
      getSTTotalTimeByDay: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, horaInicio, horaFin }) => ({
          url: `estadisticas/sessions/TotalTimeByDay`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, horaInicio, horaFin },
        }),
        providesTags: ["Events"],
      }),
      /* Messages */
      getMessages: builder.query({
        query({ Token }) {
          return {
            url: `turnos/messages`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        providesTags: ["Messages"],
      }),
      createMessage: builder.mutation({
        query({ Token, body }) {
          return {
            url: `turnos/messages`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Messages"],
      }),
      updateMessage: builder.mutation({
        query({ Token, id, body }) {
          return {
            url: `turnos/messages/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Messages"],
      }),
      deleteMessage: builder.mutation({
        query({ Token, id }) {
          return {
            url: `turnos/messages/${id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        invalidatesTags: ["Messages"],
      }),
      getMessagesColumns: builder.query({
        query({ Token }) {
          return {
            url: `turnos/messages/columns`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        providesTags: ["Messages"],
      }),
      /* Users */
      getSessions: builder.query({
        query({ Token, fechaInicial, fechaFinal, idUsuario }) {
          return {
            url: `estadisticas/sessions`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            params: { fechaInicial, fechaFinal, idUsuario },
          };
        },
        providesTags: ["Users"],
      }),
      getSTDTimeByUser: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, horaInicio, horaFin }) => ({
          url: `estadisticas/sessions/dtimebyuser`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, horaInicio, horaFin },
        }),
        providesTags: ["Events"],
      }),
      getSTDTimeByDay: builder.query({
        query: ({ Token, fechaInicial, fechaFinal, horaInicio, horaFin }) => ({
          url: `estadisticas/sessions/dtimebyday`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${Token}`,
          },
          params: { fechaInicial, fechaFinal, horaInicio, horaFin },
        }),
        providesTags: ["Events"],
      }),

      /* Mails */
      getMails: builder.query({
        query({ Token }) {
          return {
            url: `monitoreo/correos`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        providesTags: ["Mails"],
      }),
      createMail: builder.mutation({
        query({ Token, body }) {
          return {
            url: `monitoreo/correos`,
            method: "POST",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Mails"],
      }),
      updateMail: builder.mutation({
        query({ Token, id, body }) {
          return {
            url: `monitoreo/correos/${id}`,
            method: "PUT",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
            body,
          };
        },
        invalidatesTags: ["Mails"],
      }),
      deleteMail: builder.mutation({
        query({ Token, id }) {
          return {
            url: `monitoreo/correos/${id}`,
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          };
        },
        invalidatesTags: ["Mails"],
      }),
    }),
  },
  {
    // opciones adicionales
    fetch: async (url, options) => {
      const response = await fetch(url, {
        ...options,
        timeout: 120000, // tiempo de espera en milisegundos
      });
      return response;
    },
  }
);

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  /* Events */
  useGetEventsQuery,
  useGetEventQuery,
  useUpdateEventMutation,
  useGetSeveridadesQuery,
  /* Analista */
  useGetAnalistasQuery,
  useGetOperatorsQuery,
  /* Messages */
  useGetMessagesQuery,
  useGetMessagesColumnsQuery,
  useCreateMessageMutation,
  useUpdateMessageMutation,
  useDeleteMessageMutation,
  /* Mails */
  useGetMailsQuery,
  useCreateMailMutation,
  useUpdateMailMutation,
  useDeleteMailMutation,
  /* Users */
  useGetUsersQuery,
  useCreateUserMutation,
  useDeleteUserMutation,
  useActiveUserMutation,
  useUpdateUserMutation,
  useChangePasswordMutation,
  useRegisterSessionMutation,
  /* Statistics */
  useGetHistoricoNodoQuery,
  useGetAreaStatisticsQuery,
  useGetSeveridadStatisticsQuery,
  useGetTipoEventoStatisticsQuery,
  useGetSensoresStatisticsQuery,
  useGetEnvironmentStatisticsQuery,
  useGetPlatformStatisticsQuery,
  useLazyGetEnvironmentSensorsStatisticsQuery,
  useGetAnalistAlertsStatisticsQuery,
  useGetTiempoGestionStatisticsQuery,
  useGetAnalistTimeStatisticsQuery,
  useGetEventsReportQuery,
  useGetSTTotalTimeByUserQuery,
  useGetSTTotalTimeByDayQuery,
  useGetSessionsQuery,
  useGetSTDTimeByUserQuery,
  useGetSTDTimeByDayQuery,
  /* Sensors */
  useGetSensoresQuery,
  useUpdateSensorMutation,
  useCreateSensorMutation,
  useDeleteSensorMutation,
  /* Calendar */
  useGetAmbientesQuery,
  useGetUsersCalendarQuery,
  useCreateUserCalendarMutation,
  useGetSpecialistsQuery,
  useUpdateSpecialistsMutation,
  useCreateSpecialistsMutation,
  useDeleteSpecialistsMutation,
  useChangeStateUserCalendarMutation,
  /* Monitoreo */
  useGetConteoMonitoreoQuery,
  useGetNodosStatsQuery,
  useGetNodosStatsMonthQuery,
  useGetNodosQuery,
  useGetNodosHistoricoQuery,
  useGetNodosAlertasQuery,
  useAprobarInterfacesMutation,
  useAprobarNodosMutation,
  useAprobarVolumenesMutation,
} = yeapGoApi;
